import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { theme } from '@side/pantry';
import type { ReactNode } from 'react';

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
